var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    transform: "translate(4515.832 4367.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile_Large",
    "data-name": "Profile Large",
    transform: "translate(-4515.832 -4367.947)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component",
    transform: "translate(9 8)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M0,14V12.25c0-1.925,3.15-3.5,7-3.5s7,1.575,7,3.5V14ZM3.5,3.5A3.5,3.5,0,1,1,7,7,3.5,3.5,0,0,1,3.5,3.5Z",
    transform: "translate(0 0)",
    fill: "#1d1d1b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.c3a42f81a245dbdcbc6632e37bd408db.svg";
export { ForwardRef as ReactComponent };